/** Shared brand visuals for blurred partner teaser tiles (public + dashboard). */
export const PARTNER_TEASER_VISUALS: Record<string, { initials: string; bg: string; text: string }> = {
  "mock-1": { initials: "B&C", bg: "bg-zinc-900", text: "text-white" },
  "mock-2": { initials: "CP", bg: "bg-amber-600", text: "text-white" },
  "mock-3": { initials: "S&C", bg: "bg-sky-600", text: "text-white" },
  "mock-4": { initials: "CZ", bg: "bg-cyan-500", text: "text-white" },
  "mock-5": { initials: "GR", bg: "bg-emerald-600", text: "text-white" },
  "mock-6": { initials: "FL", bg: "bg-violet-600", text: "text-white" },
  "mock-7": { initials: "DH", bg: "bg-stone-700", text: "text-white" },
  "mock-8": { initials: "LE", bg: "bg-rose-600", text: "text-white" },
  "mock-9": { initials: "IC", bg: "bg-amber-800", text: "text-white" },
}

export type PartnerTeaserItem = {
  id: string
  partnerName: string
  discountText: string
}

/** Partner mock IDs shown in the 3×3 teaser grid (order matters). */
export const PARTNER_TEASER_IDS = [
  "mock-1",
  "mock-2",
  "mock-3",
  "mock-4",
  "mock-5",
  "mock-6",
  "mock-7",
  "mock-8",
  "mock-9",
] as const
